import React from 'react'
import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'

export const ClientOverview = withLazyRoute(
  React.lazy(() => import('./ClientOverview')),
  'Loading client overview...',
)

export const BankHome = withLazyRoute(
  React.lazy(() => import('./BankHome')),
  'Loading bank home...',
)

export const BankOnboarding = withLazyRoute(
  React.lazy(() => import('./BankOnboarding')),
  'Loading bank onboarding...',
)
